import { Component, ViewChild, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { combineLatest, Observable, of } from 'rxjs';
import {
  concatMap, map, take, takeUntil, tap
} from 'rxjs/operators';

import { DocumentVersionInput, Customer } from 'graphql/models/generated';
import { OfferBase } from 'models/offer.model';
import { BaseComponent } from 'shared/base/base.component';
import { CoreDataService } from 'shared/services/core-data.service';
import { OfferService } from 'shared/services/offer.service';
import { StoreService } from 'shared/services/store.service';

import { CustomerConditionsComponent } from '../conditions/conditions.component';

@Component({
  selector: 'app-customer-conditions-modal',
  templateUrl: './conditions-modal.component.html',
  styleUrls: ['./conditions-modal.component.scss']
})
export class CustomerConditionsModalComponent extends BaseComponent {
  @Input() showDefaultConditions = true;

  @Input() useDefaultConditions = false;

  @ViewChild(CustomerConditionsComponent) conditionsComponent!: CustomerConditionsComponent;

  customerId!: string;

  docVersion!: DocumentVersionInput;

  get form(): UntypedFormGroup {
    return this.conditionsComponent.form;
  }

  constructor(
    protected coreDataService: CoreDataService,
    private storeService: StoreService,
    private offerService: OfferService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    combineLatest([
      this.storeService.getCurrentCustomer().pipe(take(1)),
      this.storeService.getCurrentOffer().pipe(take(1))
    ]).pipe(
      takeUntil(this.destroyed$)
    )
      .subscribe(([customer, offer]: [Customer, OfferBase]) => {
        this.customerId = (customer && customer.id) || '';
        this.docVersion = { documentId: offer.documentId, revision: offer.revision };
      });
  }

  onSubmit(): Observable<Customer> {
    const formControl = (this.conditionsComponent.form.get('useDefaultConditions') as UntypedFormControl);
    const useDefaultConditions = formControl.value;

    return this.coreDataService.updateCustomer(this.customerId, this.form.value)
      .pipe(
        tap(() => this.storeService.setOfferUpdate()), // need to get new conditions
        concatMap((customer: Customer): Observable<Customer> => {
          if (!useDefaultConditions && this.docVersion && this.docVersion.documentId) {
            return this.offerService.updatePricingBasedOnConditions(this.docVersion, customer)
              .pipe(map(() => customer));
          }

          return of(customer);
        })
      );
  }
}
